import firebase from "firebase";
var firebaseConfig = {
  apiKey: "AIzaSyDuKVR9fPJfJunnmihOhNbHYnpq--wMTdc",
  authDomain: "webrtchattest.firebaseapp.com",
  databaseURL: "https://webrtchattest.firebaseio.com",
  projectId: "webrtchattest",
  storageBucket: "webrtchattest.appspot.com",
  messagingSenderId: "550205994295",
  appId: "1:550205994295:web:b6eced233a2cb6611ad6b2",
  measurementId: "G-SFWYYSKJNG",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

export default firebase;
